<template>
	<v-app-bar color="primary" dark app clipped-right short class="toolbar" :extended="extended && !$vuetify.breakpoint.mdAndUp">
		<v-navigation-drawer
			height="56"
			mini-variant
			permanent
			mini-variant-width="56"
			style="min-width: 56px;"
		>
			<v-toolbar color="primary" dark short class="mini" @click="toggleDrawer">
				<v-app-bar-nav-icon tile style="min-width: 52px; min-height: 52px;"></v-app-bar-nav-icon>
			</v-toolbar>
		</v-navigation-drawer>
		<v-toolbar-title class="px-2">
			<v-btn color="white" class="text-h5" text exact :to="{ name: 'home' }">ارتقاء</v-btn>
		</v-toolbar-title>
		
		<v-spacer></v-spacer>

		<v-toolbar-items v-if="profile">
			<v-btn icon :to="{ name: 'fav' }">
				<v-icon>mdi-bookmark-multiple</v-icon>
			</v-btn>
		</v-toolbar-items>
		<v-toolbar-items v-if="profile">
			<v-btn icon :to="{ name: 'search' }">
				<v-icon>mdi-magnify</v-icon>
			</v-btn>
		</v-toolbar-items>
	</v-app-bar>
</template>

<script>
export default {
	data() {
		return {
			extended: false
		};
	},
	computed: {
		contactInfo() {
			return this.$store.state.contactInfo;
		},
		profile() {
			return this.$store.state.profile;
		}
	},
	methods: {
		toggleDrawer() {
			if (this.$vuetify.breakpoint.mdAndUp) {
				this.$store.dispatch("setMini", !this.$store.state.mini);
			} else {
				this.$store.dispatch("setDrawer", !this.$store.state.drawer);
			}
		}
	}
};
</script>

<style scoped>
.toolbar .v-toolbar__title .v-btn__content {
	line-height: 20px;
}
</style>